module.exports = __webpack_public_path__ + "img/rightbox.acaef0b2.svg";